import React from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import { Button } from "../../../common/Button/Button";
import moment from "moment";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
//import NotesTrailDropdown from "./NotesTrailDropdown";
import NotesTrailFacilitatorDropdown from "./NotesTrailFacilitatorDropdown";
import ConfirmationModal from "./ConfirmationModal";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Select from "react-select";
import api from "../../../utils/api";
import { useState } from "react";
import CentralizedNotesModal from "../Handholder/CentralizedNotesModal";
import CentralizedSMSLogModal from "../Handholder/CentralizedSMSLogModel";
import ESPSMSTrail from "../../../containers/EServicePartnerServiceRequests/ESPSMSTrail";
import NotesTrailModal from "../Handholder/NotesTrailModal";

export default function NotesServiceFacilitatorModal(props) {

	
	// const [showNotesTrailModal, setShowNotesTrailModal] = useState(false);
	// const toggleNotesTrailModal = () => {
	// 	setShowNotesTrailModal(!showNotesTrailModal);
	// };

	
	// const [selectedCustomerEmailForNotes, setselectedCustomerEmailForNotes] = useState(null);
	// const [showNotesTrailModal, setShowNotesTrailModal] = useState(false);
	// const toggleNotesTrailModal = (nResourceInstanceId) => {
	// 	setselectedCustomerEmailForNotes(nResourceInstanceId);
	// 	setShowNotesTrailModal(!showNotesTrailModal);
	// };


	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const toggleViewAllNotesModal = () => {
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = () => {
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};


	const getSelectedItem = (Options,value) => {
		if (!Options) return null;
		const found = find(Options, {
			value: value,
		});
		if (found) {
			return found;
		}
		return null;
	};


	



	return (
		<Modal 
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
			className="conv-mdl-wd w-50"
		>
			<ModalContent>
				<div className="p-2 modal-headers-bar">
					<span>Notes</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={() => props.toggleModal(!props.isOpen)}
					>
						<X
							style={{ pointerEvents: "none" }}
							color="white"
						/>
					</button>
				</div>
				<div className="">
					{" "}
					{/* <div className="notesHistory">{renderNotesTrail()}</div> */}
					{
						// <>
						// <div className="spm-notes-details">
						// <label style={{float:"left",marginRight:"5px",marginLeft:"15px",marginTop:"5px"}}>
						// Offline Meet
						// </label>
						// <Select
						// 	//style={{innerWidth:"500px"}}
						// 	//placeholder="Select Need to talk to SP"
						// 	options={props.offlinemeetoptions}
                        //     onChange={props.setselectedofflinemeetoptions}
                        //     value={props.selectedofflinemeetoptions}
							 
						// ></Select>
						// </div>
						// {/* {<Button className="sp-inline-button"
						// onClick={props.onUpdateOfflineMeetoptions}>
						// 	Save
						// </Button>} */}
						// <div style={{clear:"both"}}></div>		
						// </>	

						//  props.service&&props.service.refExternalServicePartner?
						// (
						// 	<>
						// 		<div className="spm-notes-details">
						// 		<label style={{float:"left",marginRight:"5px",marginTop:"5px"}}>
						// 		Need to talk to SP
						// 		</label>
						// 		<Select
						// 			//placeholder="Select Need to talk to SP"
						// 			options={props.needToTalkToSPOptions}
						// 			onChange={props.setSelectedNeedToTalkToSPOption}
						// 			value={props.selectedNeedToTalkToSPOption}
						// 		></Select>
						// 		</div>
						// 		{/*<Button className="sp-inline-button"
						// 		onClick={props.onUpdateNeedToTalkToSPFlag}>
						// 			Save
						// 		</Button>*/}
						// 		<div style={{clear:"both"}}></div>		
						// 	</>	
						// ):
						// ("")
					}


						{
							props.service&&props.service.sServiceCode==="UDYAMREG" || props.service&&props.service.sServiceCode==="BOOKACCBALKEEP"
							|| props.service&&props.service.sServiceCode==="PARTSHIPDEED" || props.service&&props.service.sServiceCode==="ITR"
							|| props.service&&props.service.sServiceCode==="GSTREG" || props.service&&props.service.sServiceCode==="GSTRETURNFILING"
							|| props.service&&props.service.sServiceCode==="OPCFORM" || props.service&&props.service.sServiceCode==="PVTLTDCOMP"
							|| props.service&&props.service.sServiceCode==="LVLICENSEAGRREG" || props.service&&props.service.sServiceCode==="TRADMRK"
							|| props.service&&props.service.sServiceCode==="COPYRIGHT" || props.service&&props.service.sServiceCode==="SHOPACT"
							|| props.service&&props.service.sServiceCode==="FSSAI" || props.service&&props.service.sServiceCode==="FSSAILICENSE"
							|| props.service&&props.service.sServiceCode==="LLPFORM" || props.service&&props.service.sServiceCode==="LLPROCCOMPAMC"?
							(
								<div className="col-12 conv-mt10">
                                     
                                        {/* <label className="my-services-model-value">Offline Meet</label> */}
										<label>Offline Meet</label>
										
                                        <Select
                                                styles={{width:"30%",
                                                // Fixes the overlapping problem of the component
                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                }}    
											                                            
                                                options={props.offlinemeetoptions}
                                                onChange={props.setselectedofflinemeetoptions}
                                               	value={props.selectedofflinemeetoptions}
											
												//value={getSelectedItem(props.offlinemeetoptions,props.setselectedofflinemeetoptions)}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#76287C',
                                                        primary25: '#F4DFF4',
                                                    },
                                                    })}
													
                                            ></Select>
											 
                                         
                                    </div>
							):
							("")
						}
					
                <div className="m-3">
                    <div className="mt-2 spled-container ">
						<label>Follow up on<span>*</span></label>
						<br></br>


						<div className="width-100 ">   
						<ReactDatePicker 
                                dateFormat="dd/MM/yyyy"
                                selected={props.notesDetails &&
									props.notesDetails.dtFollowupOn
										? new Date(props.notesDetails.dtFollowupOn)
										: null}
                                onChange={(date) =>
                                    props.onInputChange("dtFollowupOn", date)
                                }
								minDate={new Date()}
                                placeholderText="Follow Up On"
								 
                            />
							</div>

							{/* <div className="mt-2">
                                        <label className="my-services-model-value">Offline Meet</label>
                                        <Select
                                                styles={{
                                                // Fixes the overlapping problem of the component
                                                menu: provided => ({ ...provided, zIndex: 3 })
                                                }}                                                
                                                options={props.offlinemeetoptions}
                                                onChange={props.setselectedofflinemeetoptions}
                                                value={props.selectedofflinemeetPOptions}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary: '#76287C',
                                                        primary25: '#F4DFF4',
                                                    },
                                                    })}
                                            ></Select>
                                    </div> */}

							
						{/* <ReactDatePicker
							dateFormat="dd/MM/yyyy"
							selected={
								props.notesDetails &&
								props.notesDetails.dtFollowupOn
									? new Date(props.notesDetails.dtFollowupOn)
									: null
							}
							onChange={(date) =>
								props.onInputChange("dtFollowupOn", date)
							}
							minDate={new Date()}
						/> */}
					</div>
					<div className="mt-2 ">
						<label>Followup Actions<span>*</span></label>
						
						<div>
							<textarea
								name="sFollowupAction"
								className="w-100 form-control rounded"
								value={
									props.notesDetails
										? props.notesDetails.sFollowupAction
										: ""
								}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					
					<div className="mt-2 mb-2 ">
						<label>
							Notes<span>*</span>
						</label>
						<div>
							<textarea
								className="w-100 form-control rounded"
								name="sNotes"
								value={
									props.notesDetails
										? props.notesDetails.sNotes
										: ""
								}
								onChange={({ target: { name, value } }) =>
									props.onInputChange(name, value)
								}
							/>
						</div>
					</div>
					<div className="mb-2">
						<Checkbox
							label="Complete"
							name="bHandled"
							id="bHandled"
							value={
								props.notesDetails
									? props.notesDetails.bHandled
									: false
							}
							checked={
								props.notesDetails
									? props.notesDetails.bHandled
									: false
							}
							onChange={({ target: { name, checked } }) =>
								props.onInputChange(name, checked)
							}
						></Checkbox>
					</div>


					<div className="flex">


						<NotesTrailFacilitatorDropdown
							notesHistory={props.auditTrail}
						></NotesTrailFacilitatorDropdown>

						{/* <span className="my-services-dnd-link con-cursor-pointer conv-float-right" 
                        onClick={()=>{ props.toggleNotesTrailModal()}}>Trail</span> */}







						 <a className="con-cursor-pointer" target="_blank"
							onClick={toggleViewAllNotesModal}

							>
						<span className="label-link conv-ml60 conv-mr10"> All Notes</span>     
						</a>
						
						<ESPSMSTrail 
							nResourceInstanceId={props.service&&props.service.nResourceInstanceId||""}
							isFromSPM={true}	 
						/>

						<a className="con-cursor-pointer" target="_blank"
							onClick={toggleViewAllSMSModal}
							>
						<span className="label-link conv-ml10"> All SMS</span>     
						</a>
						
						{/* <Button 
							onClick={toggleViewAllSMSModal}
							style={{float:"left"}}
							>
							 All SMS
						</Button> */}
					</div>
					</div>

					<div className="flex justify-content-center auditss-body">
						 	 
							<button
								type="button" 
								className="spms-cons-btns-bordered-filter conv-mr40 conv-ml30 assgn-width"
								onClick={props.toggleModal}
							>
								Cancel
							</button>
							 

							{/* <Button onClick={props.onSaveNotesDetails}>
								Save
							</Button> */}
							 
							<button className="lpms-cons-btns-filled conv-mr40 assgn-width "
                            onClick={props.onSaveNotesDetails} >
                            Save
                        	</button>			
						 
					</div>


				</div>
				<ConfirmationModal
					message="Closing the modal will discard your changes. Continue?"
					isOpen={props.isOpenConfirmationModal}
					toggleModal={props.toggleConfirmationModal}
					changeState={props.confirmChangeNotes}
				/>
			</ModalContent>



			{/* {
					showNotesTrailModal&&
					(
						<NotesTrailModal
							isOpen={showNotesTrailModal}
							toggleModal={toggleNotesTrailModal}
							//notesHistory={props.auditTrail}
							//sEmailAddress={props.service.sEmailAddress||""}
							nResourceInstanceId={props.service.nResourceInstanceId||""}
						/>
					)
				} */}
			




			{
				showViewAllNotesModal&&
				(
					<CentralizedNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={props.service.sEmailAddress||""}
					 
					>
					</CentralizedNotesModal>
				)
			}
			{
				showViewAllSMSModal&&
				(
					<CentralizedSMSLogModal
						isOpen={showViewAllSMSModal}
						toggleModal={toggleViewAllSMSModal}
						sEmailAddress={props.service.sEmailAddress||""}
					>
					</CentralizedSMSLogModal>
				)
			}
		</Modal>
	);
}
